import React, { FC } from 'react';
import PageNotFound from 'components/common/PageNotFound';

const Error: FC = (): JSX.Element => {
  return <PageNotFound />;
};

export default Error;
